/**
 * Shared helper for the per-page translation modules under marketing/i18n/pages/*.
 * Each page owns its own {en,nl,de,fr,es,it,pt}.json + a tiny index.ts that calls this.
 */
export function loadPageTranslations(files: Record<string, Record<string, string>>, lang: string): Record<string, string> {
	return files[lang] || files.en;
}
